import { Outlet } from "react-router-dom";
import FeedbackSnackbar from "./components/FeedbackSnackbar";

export default function FgModules() {
    return (
        <>
            <Outlet />
            <FeedbackSnackbar />
        </>
    );
}
